import { NgModule } from '@angular/core';
import { StoryBlokLinkModule } from '../../../../shared/storyblok/link/link.module';

import { BaseModule } from '../../../../shared/base.module';
import { MeLandingPageImageTextComponent } from './landing-page-image-text.component';


@NgModule({
    imports: [
        BaseModule,
        StoryBlokLinkModule
    ],
    declarations: [
        MeLandingPageImageTextComponent
    ],
    exports: [
        MeLandingPageImageTextComponent
    ]
})

export class MeLandingPageImageTextModule { }
